var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInkPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11526 8.03609L10.0308 8.95159L15.6578 3.32459L14.7423 2.40909L9.11526 8.03609ZM2.06726 15.9996H2.98276L8.95201 10.0303L8.03651 9.11484L2.06726 15.0841V15.9996ZM10.5578 10.5573L7.51926 7.50934L12.002 3.02659L11.4598 2.48434C11.4084 2.433 11.3315 2.40734 11.229 2.40734C11.1263 2.40734 11.0493 2.433 10.998 2.48434L5.82126 7.66109L4.76751 6.62659L9.94826 1.43034C10.3098 1.06884 10.7373 0.888086 11.2308 0.888086C11.7244 0.888086 12.152 1.06884 12.5135 1.43034L13.0558 1.97259L14.0943 0.934337C14.2751 0.753504 14.4885 0.663086 14.7345 0.663086C14.9807 0.663086 15.1942 0.753504 15.375 0.934337L17.171 2.73034C17.3518 2.91117 17.4391 3.11825 17.4328 3.35159C17.4263 3.58492 17.3327 3.79192 17.152 3.97259L10.5578 10.5573ZM3.60576 17.4996H0.567261V14.4611L7.50976 7.50934L10.5578 10.5573L3.60576 17.4996Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkPen);
export default __webpack_public_path__ + "static/media/ink_pen.19f91c32b1e2bdd2da8bc451b50af2c1.svg";
export { ForwardRef as ReactComponent };